import ChallengeCard from "./ChallengeCard";

export default ChallengeCard;